import { makeStyles, createStyles, Theme } from "@material-ui/core/styles"
import BentonSansBook from 'assets/fonts/BentonSans-Book.otf'
import BentonSansMedium from 'assets/fonts/BentonSans-Medium.otf'
import GuardinEgypLight from 'assets/fonts/GuardianEgyp-Light.otf'

export const useStyles = makeStyles((theme: Theme) => createStyles({
    '@global': {
        '@font-face': [
            {
                fontFamily: 'Benton Sans',
                fontStyle: 'normal',
                fontWeight: 400,
                src: `url(${BentonSansBook}) format('opentype')`
            },
            {
                fontFamily: 'Benton Sans',
                fontStyle: 'normal',
                fontWeight: 500,
                src: `url(${BentonSansMedium}) format('opentype')`
            },
            {
                fontFamily: 'Guardian Egyp',
                fontStyle: 'normal',
                fontWeight: 400,
                src: `url(${GuardinEgypLight}) format('opentype')`
            }
        ],
        html: {
            height: '100%'
        },
        '#root': {
            height: '100vh',
            minHeight: '100vh',
            backgroundColor: theme.palette.background.default
        },
        main: {
            paddingBottom: '2rem'
        }
    },
    buttonBar: {
        marginTop: '1rem'
    },
    buttonBar2: {
        marginTop: '2rem',
        '& button': {
            '@media (max-width:959px)': {
                marginTop: '1rem'
            },
            '@media (min-width:960px)': {
                '&:first-child': {
                    marginRight: '1rem'
                },
                '&:last-child': {
                    marginLeft: '1rem'
                },
            },
        }
    },
    cardButtonBar: {
        '& button': {
            '@media (max-width:599px)': {
                justifyContent: 'flex-start',
                '&:nth-child(2)': {
                    marginTop: '1rem',
                }
            },
            '@media (min-width:600px)': {
                justifyContent: 'flex-start',
                '&:first-child': {
                    marginRight: '1rem'
                }
            },
        }
    },
    cardImage: {
        height: 0, 
        paddingTop: '68%',
        borderRadius: 16
    },
    cardSnapshot: {
        position: 'absolute',
        left: '-4000px',
        width: '1800px',
        padding: '2rem', 
        backgroundColor: theme.palette.background.default
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.primary.main,
    },
    dotInvisible: {
        visibility: 'hidden'
    },
    flagDeselected: {
        borderRadius: 4,
        padding: 10,
    },
    flagLabel: {
        marginTop: '0.5rem',
        fontWeight: 'bold',
        textAlign: 'center',
        textTransform: 'uppercase', 
        wordWrap: 'break-word',
        '@media (min-width:0px)': {
            fontSize: '100%',
        },
        '@media (min-width:960px)': {
            fontSize: '75%',
        },
        '@media (min-width:1280px)': {
            fontSize: '100%',
        },
    },
    flagMarketName: {
        textAlign: 'center',
        fontWeight: 'bold',
        color: theme.palette.primary.main
    },
    flagSelected: {
        borderRadius: 4, 
        padding: 7, 
        border: '3px solid',
        borderColor: theme.palette.primary.main
    },
    footprintHeader: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
    },
    footprintLegend: {
        position: 'absolute',
        right: '3rem',
        top: '3.25rem',
        '& p': {
            marginLeft: '8px'
        }
    },
    footprintDark: {
        backgroundColor: `${theme.palette.grey[200]} !important`
    },
    footprintLight: {
        backgroundColor: `${theme.palette.background.paper} !important`
    },
    footprintHidden: {
        backgroundColor: `${theme.palette.background.paper} !important`,
        border: 'none !important'
    },
    horizontalSeparator: {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    languageSelect: {
    },
    logo: {
        marginTop: '2rem',
        marginBottom: '2rem',
        width: '66px',
        height: '66px'
    },
    marketBar: {
        marginTop: '1rem'
    },
    market1: {
        backgroundColor: theme.palette.primary.dark,
        '& p': {
            color: theme.palette.common.white,
        }
    },
    market2: {
        backgroundColor: theme.palette.primary.main,
        '& p': {
            color: theme.palette.common.white,
        }
    },
    menuDivider: {
        marginTop: '1rem',
        marginBottom: '2rem'
    },
    navButton: {
        '& .MuiButton-label': {
            minHeight: 24
        }
    },
    pageHeading: {
        backgroundColor: theme.palette.background.paper,
        paddingBottom: '2rem'
    },
    paragraph: {
        marginTop: '2rem'
    },
    stepper: {
        padding: `${theme.spacing(3)}px 0px ${theme.spacing(3)}px ${theme.spacing(3)}px`
    },
    step: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    stepButton: {
        paddingTop: 0,
        paddingBottom: 0,
        textAlign: 'left'
    },
    tabIcon: {
        height: '48px', 
        marginRight: 8,
        '@media (max-width:960px)': {
            height: '32px',
        }
    },
    table: {
        borderCollapse: 'separate'
    },
    tableBox: {
        display: 'flex',
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 'auto',
        margin: '8px 24px',
        overflowY: 'auto'
    },
    tableCountryRow: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        position: 'sticky', left: 0, top: 30, zIndex: 1, backgroundColor: 'white',
    },
    tableFlag: {
        width: 33,
        height: 22
    },
    tableFlagRow: {
        '& th': {
            lineHeight: '0.8rem',
            padding: 4,
            position: 'sticky', left: 0, top: 0, zIndex: 1, backgroundColor: 'white'
        },
    },
    tableHeadingRow: {
        verticalAlign: 'bottom',
        borderBottom: `1px solid ${theme.palette.divider}`,
        position: 'sticky', zIndex: 2, backgroundColor: 'white'
    },
    tableRow: {
        '& td': {
            border: `1px solid ${theme.palette.divider}`,
            // padding: 4,
            '&:first-child': {
                borderLeft: 'none'
            },
            '&:last-child': {
                borderRight: 'none'
            }
        }
    },
    tableSmallCell: {
        padding: 4
    },
    topicsSelectorPadding: {
        paddingTop: '2rem',
        paddingBottom: '2rem'
    },
    truncateExpanded: {
        position: 'relative',
        wordWrap: 'break-word',
        paddingRight: '1rem', /* space for ellipsis */
        '&::after': {
            position: 'absolute',
            content: '"\u25b2"',
            color: theme.palette.primary.main,
            insetBlockEnd: 0, /* "bottom" */
            insetInlineEnd: 0, /* "right" */
            bottom: 0,
            right: 0
        },
    },
    truncateOverflow: {
        position: 'relative',
        wordWrap: 'break-word',
        maxHeight: `4rem`,
        overflow: 'hidden',
        paddingRight: '1rem', /* space for ellipsis */
        '&::before': {
            position: 'absolute',
            content: '"\u25bc"',
            color: theme.palette.primary.main,
            insetBlockEnd: 0, /* "bottom" */
            insetInlineEnd: 0, /* "right" */
            bottom: 0,
            right: 0
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            insetInlineEnd: 0, /* "right" */
            right: 0,
            width: '1rem',
            height: '1rem',
            background: 'white'
        }
    },
    verticalSeparator: {
        paddingRight: theme.spacing(1),
        borderRight: '1px solid',
        borderRightColor: theme.palette.divider
    },
    videoDialog: {
        backgroundColor: '#000000',
        padding: 0,
        margin: 0,
    },
    videoContent: {
        padding: 0,
        '&:first-child': {
            padding: [[4, 0]]
        }
    },
    videoPlayer: {
        width: '100%',
        height: '100%',
        margin: 'auto'
    }
}), { index: 1 }) // Ensures greater specificity for the styles over the Mui styles
